import {UiComponentBaseSchema} from "./UiComponent";
import {z} from "zod";

export const UiFieldBaseSchema = UiComponentBaseSchema.extend({
    attributeDefinitionId: z.string(),
    placeholder: z.string().optional(),
    helperText: z.string().optional(),
    readOnly: z.boolean().optional(),
});

export const UiFieldSchema = z.lazy(() => {
    const {CheckboxFieldSchema} = require("./CheckboxField");
    const {DatePickerFieldSchema} = require("./DatePickerField");
    const {DateTimePickerFieldSchema} = require("./DateTimePickerField");
    const {NumberFieldSchema} = require("./NumberField");
    const {SelectFieldSchema} = require("./SelectField");
    const {SwitchFieldSchema} = require("./SwitchField");
    const {TextFieldSchema} = require("./TextField");
    const {TimePickerFieldSchema} = require("./TimePickerField");
    
    return z.discriminatedUnion('componentType', [
        CheckboxFieldSchema,
        DatePickerFieldSchema,
        DateTimePickerFieldSchema,
        NumberFieldSchema,
        SelectFieldSchema,
        SwitchFieldSchema,
        TextFieldSchema,
        TimePickerFieldSchema,
    ]);
});

export type UiField = z.infer<typeof UiFieldSchema>;
